module.exports = __webpack_public_path__ + "static/media/gix.513f6557.jpeg";